// src/components/ViolationPredictionWidget.tsx
import React from 'react';
import { Card, CardContent, Typography, Alert, Box, Chip } from '@mui/material';
import { Warning as WarningIcon, TrendingUp as TrendingIcon } from '@mui/icons-material';

interface ViolationPredictionWidgetProps {
  prediction: any;
  vehicle: any;
}

const ViolationPredictionWidget: React.FC<ViolationPredictionWidgetProps> = ({
  prediction,
  vehicle
}) => {
  if (!prediction.hasPrediction) return null;

  const highSeverity = prediction.predictions.filter((p: any) => p.severity === 'high');

  return (
    <Card sx={{ mb: 3, borderLeft: 4, borderColor: 'warning.main' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <TrendingIcon color="warning" />
          <Typography variant="h6">
            Violation Prediction - {vehicle.plateNumber}
          </Typography>
          {highSeverity.length > 0 && (
            <Chip label={`${highSeverity.length} Critical`} color="error" size="small" />
          )}
        </Box>

        <Box sx={{ display: 'grid', gap: 2 }}>
          {prediction.predictions.map((pred: any, index: number) => (
            <Alert 
              key={index} 
              severity={pred.severity === 'high' ? 'error' : pred.severity === 'medium' ? 'warning' : 'info'}
              icon={<WarningIcon />}
            >
              <Typography variant="body2" fontWeight="bold">
                {pred.message}
              </Typography>
              <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                Estimated: {pred.estimatedTimeMinutes} minutes
              </Typography>
            </Alert>
          ))}
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          Predictions based on current trajectory at {Math.round(prediction.speed)} km/h
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ViolationPredictionWidget;